<template>
    <div class="news-publication-date">{{ dateString }}</div>
</template>
<script>
export default {
    name: 'NewsPublicationDate',
    props: {
        date: Date
    },
    computed:{
        dateString(){
            let month = this.date.getMonth()
            let day = this.date.getDate().toString()
            let year = this.date.getFullYear().toString()
            let monthNames = {
                0:'января',
                1:'февраля',
                2:'марта',
                3:'апреля',
                4:'мая',
                5:'июня',
                6:'июля',
                7:'августа',
                8:'сентября',
                9:'октября',
                10:'ноября',
                11:'декабря'
            }
            let monthName = monthNames[month]
            return 'Дата публикация новости:  ' + day + ' ' + monthName +' '+ year +' г.'
        }
    }
}
</script>